if (!customElements.get('megamenu-element')) {
  class megamenuElement extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        menuLinks: '[data-nav-level="1"] [menu-link]',
        menuChildLinks: '[data-nav-level="2"] [menu-link]',
        menuGrandChildLinks: '[data-nav-level="3"] [menu-link]',
        mainMenuList: '[menu-main-list]',
        childMenuList: '[menu-child-list]',
        grandMenuList: '[menu-grand-list]',
        megamenuImage: '[megamenu-image]'
      };
      this.initSelectors();
      this.initEvt();
    }

    initSelectors() {
      this.menuLinks = this.querySelectorAll(this.selectors.menuLinks);
      this.menuChildLinks = this.querySelectorAll(this.selectors.menuChildLinks);
      this.menuGrandChildLinks = this.querySelectorAll(this.selectors.menuGrandChildLinks);
      this.childMenuLists = this.querySelectorAll(this.selectors.childMenuList);
      this.grandMenuLists = this.querySelectorAll(this.selectors.grandMenuList);
      this.megamenuImage = this.querySelector(this.selectors.megamenuImage);
    }
 
    handleToggle(links, target, lists, parentId) {
      links.forEach(l => l.classList.remove('active'));
      target.classList.add('active');
      if (lists && lists.length > 0)
        lists?.forEach(list => {
          if (list.getAttribute('data-parent') === parentId) {
            list.classList.remove('hidden');
            setTimeout(() => { list.classList.add('active'); }, 100);
          } else {
            list.classList.remove('active');
            list.classList.add('hidden');
          }
        });
    }

    handleMediaChange(element) {
      const image = element.getAttribute('data-image');
      console.log(image, "IMGE", this.megamenuImage);
      if (image && image !== '') {
        this.megamenuImage.src = image;
        console.log(this.megamenuImage);
      }
    }

    initEvt() {
      this.menuLinks?.forEach(link => {
        link?.addEventListener('mouseenter', () => {
          const parentId = link.getAttribute('data-id');
          this.handleToggle(this.menuLinks, link, this.childMenuLists, parentId);
          this.grandMenuLists?.forEach(list => { list.classList.remove('active'); list.classList.add('hidden'); });
          this.handleMediaChange(link);
        });
      });

      this.menuChildLinks?.forEach(link => {
        link?.addEventListener('mouseenter', () => {
          const childId = link.getAttribute('data-id');
          this.handleToggle(this.menuChildLinks, link, this.grandMenuLists, childId);
          this.handleMediaChange(link);
        });
      });

      this.menuGrandChildLinks?.forEach(link => {
        link?.addEventListener('mouseenter', () => {
          this.handleToggle(this.menuGrandChildLinks, link);
          this.handleMediaChange(link);
        });
      });
    }
  }
  customElements.define('megamenu-element', megamenuElement);
}